module.exports = __webpack_public_path__ + "thumbnail.d0f42c8a.png";